import React, { Component } from "react";
// const iconPlugi = <img src="/assets/images/icons/pPlugify.svg" alt="Plugify" />


class AboutPlugify extends Component {
    render() {
        // let title = 'Quem somos',
        let subtitle = 'Alugamos equipamentos de TI para sua empresa'
        // description2 = 'Com a Plugify a conta fecha na prática';

        return (
            <React.Fragment>
                <div className="bg-quemsomos-plug">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5 col-md-12">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/imgAbout-left.png" alt="About Images" />
                                    </div>
                                </div> */}
                                <div className="col-lg-7 col-md-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            {/* <div className="iconPlug">
                                                <div className="iconP" style={{ width: 25, textAlign:"center" }}>
                                                    {iconPlugi}
                                                </div>
                                            </div> */}
                                            {/* <div className="contentPlugify" style={{ paddingTop: 100 }}> */}
                                            <div className="boxTextSobre">
                                                {/* <h2 className="title titleProdApple">{title}</h2> */}
                                                <h2 className="title subtitleProdApple" >{subtitle}</h2>
                                                {/* <span className="descriptionApple">A <strong>Plugify</strong> é um <strong>Apple Authorized Corporate Reseller</strong> e tem acesso às melhores ofertas e às mais recentes inovações que a Apple traz para o mundo corporativo, desde o super-poderoso chip M1, aos melhores métodos de ﬁnanciamento, via Apple Financial Services</span> */}
                                                <span className="descriptionApple">
                                                    {/* Somos rápidos e simplificamos o aluguel de equipamentos de TI.<br /> */}
                                                    {/* Entregamos a verdadeira e desejada leveza do “asset light”.<br />
                                                    Removemos o peso de múltiplos pontos de contato e pilhas de contratos com letras miúdas e confusas.<br />
                                                    Com a agilidade de sua plataforma e simpatia de seu time, a Plugify traz agora tudo em um único lugar. */}
                                                    Nosso objetivo é surpreender e encantar os mais inovadores e exigentes clientes.</span>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default AboutPlugify;